import type { DocxFlowEditorAdapter } from '@dealstack/frontend/shared/components/FieldBinding/DocxFieldBinding/docxFlowEditor.adapter.ts';
import { useDocxSignatureSlots } from './useDocxSignatureSlots.ts';
import { useDocxDateAnchors } from './useDocxDateAnchors.ts';
import {
	useDocxFlowDocumentQuery,
	useSaveDocxFlowDocument,
} from '../../api/useDocxFlowDocument.ts';
import { useDataPointCatalogueQuery } from '../../api/useDataPointCatalogueQuery.ts';
import { useDocxTemplateRender } from '../../api/useDocxTemplateRender.ts';
import { useProgrammeCohorts } from '../../api/useProgrammeCohorts.ts';
import { useInvestorOptions } from './useInvestorOptions.ts';

/**
 * The Word editor, wired to a deal's master document. Module-level, as the contract requires:
 * its members are hooks. Every one is the hook the editor called directly before — this file is
 * the seam, not a behaviour change.
 */
export const dealDocxFlowAdapter: DocxFlowEditorAdapter = {
	useFlowDocument: (templateId) => useDocxFlowDocumentQuery(templateId),
	useSaveFlowDocument: () => useSaveDocxFlowDocument(),
	useCatalogue: (templateId, investorId) => useDataPointCatalogueQuery(templateId, investorId),
	useRender: () => useDocxTemplateRender(),
	useSignatureSlots: (templateId, document) => useDocxSignatureSlots(templateId, document),
	useDateAnchors: (templateId, document) => useDocxDateAnchors(templateId, document),
	// Always enabled: a master document only opens inside a deal, so there are investors to list.
	useInvestorPreview: ({ preload }) => ({
		isAvailable: true,
		...useInvestorOptions({ enabled: true, preload }),
	}),
	useCohorts: () => useProgrammeCohorts(),
};
